import { Button } from "@/components/ui/button";
import { AlertCircle } from "lucide-react";

const AuthLinkError = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-slate-50 to-white flex items-center justify-center px-6">
      <div className="w-full max-w-xl rounded-2xl border border-slate-200 bg-white shadow-sm p-8 sm:p-10 text-center">
        <div className="mx-auto mb-5 h-14 w-14 rounded-full bg-amber-100 flex items-center justify-center">
          <AlertCircle className="h-7 w-7 text-amber-700" />
        </div>

        <h1 className="text-2xl font-semibold text-slate-900 mb-4">
          Link not available
        </h1>

        <p className="text-slate-600 leading-relaxed mb-8">
          This access link has already been used or has expired.
          <br />
          You can still access your personal area by logging in from the homepage below.
        </p>

        <Button asChild className="h-11 px-7 bg-[#030A14] hover:bg-[#0a1324] text-white">
          <a href="https://planner.place2be.it/#/login">
            Go to Login
          </a>
        </Button>
      </div>
    </div>
  );
};

export default AuthLinkError;
